export default __webpack_public_path__ + "static/media/hmong.acd7606d.svg";